export default {
  LOAD_QUICK_LINKS (state, payload) {
    state.quickLinks = payload
  },
  LOAD_PLANNING_STREAM (state, payload) {
    state.planningStream = payload
    state.dashboardPlanning = payload.programGuides
  },
  LOAD_CLUB_RECOMMENDATIONS (state, payload) {
    state.clubRecommendations = payload
  },
  LOAD_EVENT_RECOMMENDATIONS (state, payload) {
    state.eventRecommendations = payload
  },
  LOAD_JOB_RECOMMENDATIONS (state, payload) {
    state.jobRecommendations = payload
  },
  LOAD_LEARNER_DASHBOARD_STATE (state, payload) {
      state.learnerDashboardState = payload
  },
  LOAD_LEARNER_ENROLLMENT_DATA (state, payload) {
      state.learnerEnrollmentData = payload
  },
  LOAD_LEARNER_DASHBOARD_COMPONENTS (state, payload) {
      state.learnerDashboardComponents = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/vuex/mutations.js